import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfirmDialogBoxComponent } from './confirm-dialog-box.component';
import { ConfirmDialogData } from './confirm.model';
@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  confirmDialog(data: ConfirmDialogData): Observable<boolean> {
    return this.dialog
      .open(ConfirmDialogBoxComponent, {
        data,
        width: '500px',
        autoFocus:false,
        disableClose: true,
        panelClass: "custom-dialog-container_4",
      })
      .afterClosed();
  }
}